import { lazy } from 'react';
import { HomeOutlined, AppstoreOutlined } from '@ant-design/icons';
// import {
//   appConstants,
//   resourceConstants,
//   actionConstants,
// } from 'constants/index';
import { t } from 'helpers/i18n';

// const { TERRA } = appConstants;
// const { APP } = resourceConstants;
// const { READ, CREATE, UPDATE } = actionConstants;

// const permission = (app: string, resource: string, action?: string) => ({
//   app,
//   resource,
//   action,
// });

// App pages
const Applications = lazy(() =>
  import('containers/Product/Applications/Applications')
);
const Modules = lazy(() => import('containers/Product/Modules/Modules'));
const User = lazy(() => import('containers/Product/User'));

/*
 * If route has children, it's a parent menu (not link to any pages)
 * You can change permissions to your IAM's permissions for testing
 */
const routes = [
  {
    exact: true,
    path: '/products/:productCode/users',
    name: t('User'),
    component: User,
    icon: HomeOutlined,
    //permissions: [permission(TERRA, APP, READ)],
  },
  {
    exact: true,
    path: '/products/:productCode/apps',
    name: t('Applications'),
    component: Applications,
    icon: AppstoreOutlined,
    //permissions: [permission(TERRA, APP, READ)],
  },
  {
    exact: true,
    path: '/products/:productCode/modules',
    name: t('Modules'),
    component: Modules,
    icon: AppstoreOutlined,
    //permissions: [permission(TERRA, APP, READ)],
  },
];

export default routes;
